// import Cookies from "js-cookie";
import { useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { ErrorMessage, Field, Form, Formik } from "formik";
import {
  loginMobileInitialValues,
  loginMobileValidationSchema,
} from "@/constants/Auth";
import { TextError } from "../Helpers/InputContainer";
import { useTranslation } from "next-i18next";
import { setCookie } from "cookies-next";
import { loginByEmailOrMobile } from "@/services/auth/login";
import toast from "react-hot-toast";
import TurnstileRecaptcha from "@/components/turnstile/TurnstileRecaptcha";
import { useTurnstile } from "react-turnstile";

function LoginMobile({ Context, setLogin, setLoginMobile, loginMobile }) {
  const {
    t,
    i18n: { language },
  } = useTranslation("common");
  const [remember, setRemember] = useState(false);
  const turnstile = useTurnstile();

  const handleLogin = async (values, { setFieldValue }) => {
    const res = await loginByEmailOrMobile({
      value: values.useremailphone,
      recaptchaToken: values.token,
    });
    if (res?.data?.success !== "false" && res?.status === 200) {
      Context?.dispatch({ type: "otpMobileModal" });
      setCookie("email-phone", values.useremailphone);
      toast.success(res?.data?.successmsg);
    } else {
      const error =
        res?.err?.response?.data?.error?.message?.errormsg ||
        res?.err?.response?.data?.error?.successmsg;
      res?.err?.response?.data?.error?.message?.successmsg;
      toast.error(
        error
          ? error
          : res?.data?.errormsg
          ? t(res?.data?.errormsg)
          : language === "en"
          ? "Something went wrong, please try again"
          : "حدث خطأ ما, الرجاء المحاولة مرة أخرى"
      );
      turnstile.reset();
      setFieldValue("token", "");
    }
  };
  return (
    <Formik
      initialValues={loginMobileInitialValues}
      validationSchema={loginMobileValidationSchema(t)}
      onSubmit={handleLogin}
    >
      {({ isSubmitting, setFieldValue }) => (
        <Form>
          <div className="grid grid-cols-2 mb-2">
            <button type="button" className="block w-full mb-1 font-semibold ">
              <span
                onClick={() => {
                  setLogin(false);
                  setLoginMobile(true);
                }}
                className="py-1 cursor-pointer hover:text-primary campaign:hover:text-campaignAccent hover:border-b-primary campaign:hover:border-b-campaignAccent"
              >
                {language === "en"
                  ? "Login using password"
                  : "تسجيل بإستخدام كلمة المرور"}
              </span>
            </button>
            <button
              type="button"
              className="block w-full mb-1 font-semibold cursor-pointer"
            >
              <span
                onClick={() => {
                  setLogin(true);
                  setLoginMobile(false);
                }}
                className={`py-1 cursor-pointer hover:text-primary campaign:hover:text-campaignAccent ${
                  !loginMobile ? "border-b border-b-primary campaign:border-b-campaignAccent" : ""
                } hover:border-b-primary campaign:hover:border-b-campaignAccent`}
              >
                {language === "en"
                  ? "Login via Otp"
                  : "تسجيل بإستخدام رمز التحقق"}
              </span>
            </button>
          </div>
          <div className="mb-2">
            <label
              htmlFor="useremailphone"
              className="block w-full mb-1 font-semibold cursor-pointer"
            >
              {t("Email_phone")}
            </label>
            <Field
              name="useremailphone"
              className="w-full p-2 border rounded-md outline-0"
              placeholder={t("Email_phone")}
              id="useremailphone"
            />
            <ErrorMessage name="useremailphone" component={TextError} />
          </div>
          <div className="flex items-center justify-between mb-2">
            <div
              onClick={() => setRemember(!remember)}
              className="flex items-center"
            >
              <div className="relative w-4 h-4 bg-white border border-gray-300 rounded-sm">
                {remember && (
                  <AiOutlineCheck
                    size={13}
                    className="absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 text-red"
                  />
                )}
              </div>
              <span className="mx-2 cursor-pointer text-zinc-600">
                {t("RememberMe")}
              </span>
            </div>
            <button
              onClick={() => Context?.dispatch({ type: "forgotModal" })}
              type="button"
              className="underline text-zinc-600"
            >
              {t("ForgotPassword")}
            </button>
          </div>
          <TurnstileRecaptcha
            action="mobile-login-otp"
            className="flex justify-center items-center p-2"
            onVerify={(value) => {
              setFieldValue("token", value);
            }}
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full p-2 font-bold text-white rounded-md bg-blue campaign:bg-campaignAccent hover:bg-lightred disabled:cursor-not-allowed"
          >
            {t(isSubmitting ? "Sending" : "Send")}
          </button>
        </Form>
      )}
    </Formik>
  );
}

export default LoginMobile;
